import useGetEmployees from "../hooks/useGetEmployees";
import { useProdFranchiseType } from "../hooks/useGetProdFranchiseTypes";
import { ProducerCodeCarrierSection } from "./ProducerCodeCarrierSection";
import { ProducerCodeLOBSection } from "./ProducerCodeLOBSection";
import ProducerCodeProducerSection from "./ProducerCodeProducerSection";
import ProducerCodeMapping from "./ProducerCodeMapping";
import ProducerCodeNotes from "./ProducerCodeNotes";

const ProducerCodeDetails = ({ rowForEdit, isAddState }) => {
  const { data: employeeList, isFetching: employeeListLoading } =
    useGetEmployees();

  const hasIssuedTo = Array.isArray(rowForEdit?.issuedTo)
    ? rowForEdit.issuedTo
        .map((x) => Number(x?.value))
        .filter((x) => !Number.isNaN(x))
    : [];

  const issuedToList = isAddState
    ? employeeList?.filter((x) => x.status !== "Terminated")
    : employeeList?.filter(
        (x) => hasIssuedTo.includes(x.employeeId) || x.status !== "Terminated"
      );

  const empFranchisesOpts = issuedToList
    ?.filter(
      (x) =>
        x.employeeId !== null &&
        x.employeeId !== "" &&
        x.employeeTypeName === "Franchise"
    )
    ?.map(
      (x: {
        employeeId: number;
        fullname: string;
        employeenumber: string;
        distributionChannel: string;
      }) => {
        return {
          label: x.fullname + " - " + x.employeenumber,
          value: x.employeeId?.toString(),
          channel: x.distributionChannel,
        };
      }
    );

  var confieEmpOpts = issuedToList
    ?.filter(
      (x) =>
        x.employeeId !== null &&
        x.employeeId !== "" &&
        x.employeeTypeName !== "Franchise"
    )
    ?.map(
      (x: {
        employeeId: number;
        fullname: string;
        employeenumber: string;
        distributionChannel: string;
      }) => {
        return {
          label: x.fullname + " - " + x.employeenumber,
          value: x.employeeId?.toString(),
          channel: x.distributionChannel,
        };
      }
    );

  const { data: franchiseTypeData } = useProdFranchiseType();
  const franchiseTypeOpt = franchiseTypeData?.map((x) => {
    return {
      value: x.franchiseTypeId,
      label: x.franchiseTypeName,
    };
  });
  return (
    <div className="bg-white box-shadow rounded-lg h-full">
      <div className="space-y-2 p-2 mb-3">
        <div className="">
          <ProducerCodeCarrierSection
            confieEmpOpts={confieEmpOpts}
            empFranchisesOpts={empFranchisesOpts}
            employeeListLoading={employeeListLoading}
            franchiseType={franchiseTypeOpt}
          />
        </div>
        <div className="">
          <ProducerCodeProducerSection />
        </div>
        <div className="">
          <ProducerCodeLOBSection
            confieEmpOpts={confieEmpOpts}
            empFranchisesOpts={empFranchisesOpts}
            employeeListLoading={employeeListLoading}
            franchiseType={franchiseTypeOpt}
          />
        </div>
        <div className="">
          <ProducerCodeMapping producerCodeRow={rowForEdit} />
        </div>
        <div className="">
          <ProducerCodeNotes />
        </div>
      </div>
    </div>
  );
};

export default ProducerCodeDetails;
